module.exports = __webpack_public_path__ + "img/logo.63df6ba6.png";